export enum CompanyPermission {
  CREATE = 'create',
  EDIT = 'edit',
  DELETE = 'delete',
  VIEW = 'view',
  ROLES = 'roles',
  CREATE_BANK_ACCOUNT = 'create-bank-account',
};
